import { Injectable } from '@angular/core';
import { BaseApiService } from '../../../shared/base-service/base-api.service';
import { VehicleSearchCriteria } from './vehicle-search-criteria.model';
import { Observable, throwError } from 'rxjs';
import { VehicleSearchResult } from './vehicle-search-result.model';
import { map, catchError } from 'rxjs/operators';
import { HttpErrorResponse } from '../../../../node_modules/@angular/common/http';

@Injectable()
export class VehicleSearchService extends BaseApiService {

    public searchVehicles = (VehicleSearchCriteria) => this.post('Vehicle/Vehicle/Search', VehicleSearchCriteria);

    public searchVehiclesAdvanced(vehicleSearchCriteria: VehicleSearchCriteria): Observable<VehicleSearchResult[]> {
        return this.post('Vehicle/Vehicle/Search/Advanced', vehicleSearchCriteria).pipe(map(r => r.results), catchError(this.catchError));
    }

    private catchError(err: HttpErrorResponse) {
        if (err.error && err.error.validationResults && err.error.validationResults.length) {
            return throwError(err.error);
        }
        let validationResults = [{ errorMessage: 'Server Error' }];

        return throwError({ validationResults: validationResults });
    }
}
